// extracted by mini-css-extract-plugin
export default {"buTabActive":"_2n9opyi1KeBrLccY6hJnUT","buTab":"_21GTTY8HSLNevLtcpQkLoE","buttonGroup":"_26dcZwnY_wBQ6a24qGZ8B8"};